const isLocalTms = process.env.REACT_APP_TMS_LOCAL === 'true';

const TENANT_MGMT_SERVICE = '/tenant-mgmt';
const TENANT_MGMT_SERVICE_API = '/api';

const TMS_LOCAL_URL = `http://localhost:8001${TENANT_MGMT_SERVICE_API}`;
const TMS_STAGING_URL = `${TENANT_MGMT_SERVICE}${TENANT_MGMT_SERVICE_API}`;

export const TENANT_MGMT_SERVICE_BASE_URL = isLocalTms ? TMS_LOCAL_URL : TMS_STAGING_URL;
